import { ChartOptionsProvider, CHART_FLEXED_MARKER } from "./chart-options";
import { Injectable } from "@angular/core";
import { OIL_AND_GAS_TITLE } from "@williswelby/platform";

@Injectable()
export class IroceChartOptionsProvider extends ChartOptionsProvider {
  public getOptions(company, flexedExpectation, flexedData = {}) {
    const iroceHistoric = company.platformData.iroceHistoric.slice(-13),
      iroceForecast = company.platformData.iroceForecast,
      flexedWci = flexedData["valueDrivers"]
        ? flexedData["valueDrivers"]["wci"]
        : [],
      flexedFai = flexedData["valueDrivers"]
        ? flexedData["valueDrivers"]["fai"]
        : [],
      flexedEbits = flexedData["valueDrivers"]
        ? flexedData["valueDrivers"]["ebitMargin"]
        : [],
      iroceCap = company.platformData.iroceCap,
      iroceExpectation = company.platformData.iroceExpectation,
      expectationYear = iroceCap[iroceCap.length - 1].year + 1;

    const chartType =
      company.industry == OIL_AND_GAS_TITLE
        ? "Net Intrinsic ROCE (NIROCE)"
        : "Intrinsic ROCE (IROCE)";
    const shortChartType =
      company.industry == OIL_AND_GAS_TITLE ? "NIROCE" : "IROCE";

    const iroceExpectationPercent = (
      company.platformData.iroceExpectation * 100
    ).toFixed(1);
    const iroceHistoricPercent = (
      iroceHistoric[iroceHistoric.length - 1].value * 100
    ).toFixed(1);
    let flexedIroce = [];
    let chartOptions;

    if (flexedExpectation) {
      flexedIroce = flexedEbits
        .map((item) => {
          const newWci = flexedWci.find((w) => w.year == item.year);
          const newFai = flexedFai.find((f) => f.year == item.year);
          const oldFai = company.platformData.valueDrivers.fai.find(
            (f) => f.year == item.year
          );
          const oldWci = company.platformData.valueDrivers.wci.find(
            (w) => w.year == item.year
          );
          if ((!newWci && !oldWci) || (!newFai && oldFai)) return;
          if (newFai.value == oldFai.value && newWci.value == oldWci.value)
            return;
          if (item.value)
            return {
              year: item.year,
              value: this.calculateIroce(
                item.value,
                newWci.value,
                newFai.value,
                flexedData["rates"].taxRate,
                company.industry
              ),
            };
        })
        .filter((i) => i != null && i.year !== expectationYear);
    }

    chartOptions = {
      chart: Object.assign(this.defaultChartOptions.chart, {
        spacingBottom: 80,
      }),
      credits: {
        enabled: true,
        text: `Implied ${chartType}: ${iroceExpectationPercent}% <br/>Trailing ${chartType}: ${iroceHistoricPercent}%`,
        style: {
          color: "#333",
          cursor: "pointer",
          fontSize: "12px",
        },
        position: {
          align: "left",
          verticalAlign: "bottom",
          x: 10,
          y: -20,
        },
      },
      title: `${chartType} consistent with share price`,
      legend: this.defaultChartOptions.legend,
      xAxis: {
        minTickInterval: 1,
      },
      yAxis: {
        title: {
          text: null,
        },
      },
      tooltip: this.defaultChartOptions.tooltip,
      series: [
        {
          color: "#2078b3",
          marker: {
            symbol: "circle",
          },
          name: "Historic",
          data: iroceHistoric.map((item) => [item.year, item.value * 100]),
          visible: true,
        },
        {
          name: "Forecast",
          data: iroceForecast
            .filter((item) => !!item)
            .map((item) => [item.year, item.value * 100]),
          visible: true,
        },
        {
          name: "CAP",
          data: iroceCap.map((item) => [item.year, item.value * 100]),
          visible: true,
        },
        {
          name: "Expectation",
          type: "line",
          data: [[expectationYear, iroceExpectation * 100]],
          visible: true,
        },
      ],
    };
    if (flexedExpectation) {
      chartOptions.series.push({
        name: "Flexed Expectation",
        type: "line",
        data: [[expectationYear, flexedExpectation * 100]],
        visible: true,
        marker: {
          symbol: CHART_FLEXED_MARKER,
        },
      });
      chartOptions.series.push({
        name: "Flexed Values",
        data: flexedIroce.map((item) => [item.year, item.value * 100]),
        visible: true,
        color: "black",
        marker: {
          symbol: CHART_FLEXED_MARKER,
        },
      });
      chartOptions.credits.text = `Implied ${shortChartType}: ${iroceExpectationPercent}% Flexed ${shortChartType} Expectation: ${(
        flexedExpectation * 100
      ).toFixed(1)}%<br/>Trailing ${shortChartType}: ${iroceHistoricPercent}%`;
    }

    chartOptions = this.setYMax(chartOptions);
    chartOptions = this.setYMin(chartOptions);
    return super.getOptions(company, chartOptions);
  }

  calculateIroce(ebitM, wci, fai, taxRate, industry) {
    let netAdjuster = 1;
    if (industry === OIL_AND_GAS_TITLE) {
      netAdjuster = 1 - taxRate;
    }
    const iroce = (netAdjuster * ebitM) / (fai + wci);
    return isFinite(iroce) ? iroce : null;
  }
}



// WEBPACK FOOTER //
// ./src/providers/chart-options/iroce-options.ts